import React from 'react';
import styled from 'styled-components';

const Label = ({ section, label }) => (
  <>
    {section}
    <Divider />
    {label}
  </>
);

export default Label;

const Divider = styled.hr`
  width: 28px;
  border-color: ${({ theme }) => theme.colors.dutchiePlusGreen[35]};
  border-bottom: 0;
  border-top: 2.5px solid;
  border-right: 0;
  border-left: 0;
  margin: 0 8px;
`;
